import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import { GridColDef } from '@mui/x-data-grid-pro';
import { FC, useMemo } from 'react';

import type { AdditionalDataInput } from '../../../../types';
import { ReorderableDataGrid } from '../../../ReorderableDataGrid';

const ROW_HEIGHT = 45;
interface DataFieldListProps {
  fields: AdditionalDataInput[];
  onEditField: (fieldId: string) => void;
  onReorderFields: (fields: AdditionalDataInput[]) => void;
}

export const DataFieldList: FC<DataFieldListProps> = ({
  fields,
  onEditField,
  onReorderFields,
}) => {
  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: 'label',
        headerName: 'Label',
        flex: 1,
      },
      {
        field: 'actions',
        headerName: '',
        width: 60,
        sortable: false,
        renderCell: (params) => (
          <IconButton
            size="small"
            onClick={() => onEditField(params.row.id)}
            sx={{ padding: 0.5 }}
            aria-label={`Edit ${params.row.label}`}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        ),
      },
    ],
    [onEditField]
  );

  return (
    <ReorderableDataGrid
      data={fields}
      columns={columns}
      onReorder={onReorderFields}
      rowHeight={ROW_HEIGHT}
      emptyStateMessage="No data fields configured."
    />
  );
};
